import { render, staticRenderFns } from "./RiderAssignedOrder.vue?vue&type=template&id=37df4725&"
import script from "./RiderAssignedOrder.vue?vue&type=script&lang=js&"
export * from "./RiderAssignedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports